import { Accordion } from "@app/shared/Accordion"
import TooltipWrapper from "@app/shared/TooltipWrapper";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { FC, useContext } from "react"
import { ProviderHubContext } from "@app/projects/network-assessment/provider-hub/contexts/ProviderHubContext";
import { getCareJourneyDefinitions } from "@app/projects/servicing-provider/ServicingProviderHelpers";
import { displayFraction } from "@app/projects/utility";

export const ContractEntityProfileCareJourney: FC = () => {
  const providerHubContext = useContext(ProviderHubContext);
  const { selectedContractEntity } = providerHubContext;

  return (
    <Accordion
      title={
            <><span>CareJourney Provider Performance</span><img src={`${window.customUIBaseUrl}/images/carejourney-logo.svg`} alt="Arcadia CareJourney" width="120" height="30" /></>
      }
      testId="provider-profile__carejourney-accordion"
      defaultOpen={true}
    >
      <dl>
        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">
            Cost Score
            <TooltipWrapper text={getCareJourneyDefinitions()} position="right" tooltipWidth="300px">
              <div className="waffles-tooltip-indicator">
                &nbsp;
                <QesIcon iconName={QesIcons.InfoCircle} description="Info" width="14" testId="provider-profile__carejourney-cost-tooltip-info-icon"/>
              </div>
            </TooltipWrapper>
          </dt>
          <dd className="provider-profile__overview-value">
            {displayFraction(selectedContractEntity?.careJourneyCost, 5)}
          </dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">
            Quality Score
            <TooltipWrapper text={getCareJourneyDefinitions()} position="right" tooltipWidth="300px">
              <div className="waffles-tooltip-indicator">
                &nbsp;
                <QesIcon iconName={QesIcons.InfoCircle} description="Info" width="14" testId="provider-profile__carejourney-quality-tooltip-info-icon"/>
              </div>
            </TooltipWrapper>
          </dt>
          <dd className="provider-profile__overview-value">
            {displayFraction(selectedContractEntity?.careJourneyQuality, 5)}
          </dd>
        </div>
      </dl>
    </Accordion>
  )
};